import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { HeaderContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

export interface TransactionListTotalCostHeaderProps
  extends HeaderContext<TransactionModel, TransactionModel['totalCost']> {}

export const TransactionListTotalCostHeader = (
  props: TransactionListTotalCostHeaderProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { column } = props;
  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack key={column.id} justifyContent="flex-end">
      {t('delmonicos-shared-sdk.outputs-transaction.total-cost')}
    </Stack>
  );
};
